/* src/app/components/dialogs/select-filter/select-filter.component.scss */
mat-dialog-content mat-expansion-panel {
  margin-bottom: 4px;
}
.row {
  display: flex;
}
.row :nth-child(2) {
  margin: 0px 10px;
}
.row mat-form-field {
  width: 100%;
}
.list {
  height: 100px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
}
/*# sourceMappingURL=select-filter.component.css.map */
